import React from "react";

const Footer: React.FC = () => {
  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* About Us */}
            <div className="lg:col-span-1">
              <h3 className="text-xl font-semibold mb-6 text-white border-b border-gray-700 pb-2">
                About Us
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                We Provide IT Software Development and Digital Marketing
                Consulting Services that offer a holistic platform to digitally
                transform and empower businesses with cutting-edge technologies.
                We are your trusted partner in carving out the roadmap of your
                business from strategy to execution.
              </p>
              <div className="flex space-x-3">
                <a
                  href="https://www.facebook.com/elenoitdigital"
                  target="_blank"
                  rel="noreferrer"
                  className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-900 hover:bg-blue-600 hover:text-white transition-colors duration-300"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/in/elenoit-digital-solution-a90191245"
                  target="_blank"
                  rel="noreferrer"
                  className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-900 hover:bg-blue-700 hover:text-white transition-colors duration-300"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Our Services */}
            <div>
              <h3 className="text-xl font-semibold mb-6 text-white border-b border-gray-700 pb-2">
                Our Services
              </h3>
              <ul className="space-y-3">
                <li>
                  <a
                    href="/services#web-development"
                    onClick={handleLinkClick}
                    className="text-gray-300 hover:text-white transition-colors duration-300"
                  >
                    IT Solution
                  </a>
                </li>
                <li>
                  <a
                    href="/services#web-development"
                    onClick={handleLinkClick}
                    className="text-gray-300 hover:text-white transition-colors duration-300"
                  >
                    Web Development
                  </a>
                </li>
                <li>
                  <a
                    href="/services#earned-owned-media"
                    onClick={handleLinkClick}
                    className="text-gray-300 hover:text-white transition-colors duration-300"
                  >
                    Digital Marketing
                  </a>
                </li>
                <li>
                  <a
                    href="/services#strategy-consulting"
                    onClick={handleLinkClick}
                    className="text-gray-300 hover:text-white transition-colors duration-300"
                  >
                    SEO Optimization
                  </a>
                </li>
                <li>
                  <a
                    href="/services#web-development"
                    onClick={handleLinkClick}
                    className="text-gray-300 hover:text-white transition-colors duration-300"
                  >
                    App Optimization
                  </a>
                </li>
              </ul>
            </div>

            {/* Useful Links */}
            <div>
              <h3 className="text-xl font-semibold mb-6 text-white border-b border-gray-700 pb-2">
                Useful Links
              </h3>
              <ul className="space-y-3">
                <li>
                  <a
                    href="/privacy"
                    onClick={handleLinkClick}
                    className="text-gray-300 hover:text-white transition-colors duration-300"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a
                    href="/termsAndConditions"
                    onClick={handleLinkClick}
                    className="text-gray-300 hover:text-white transition-colors duration-300"
                  >
                    Terms & Conditions
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-xl font-semibold mb-6 text-white border-b border-gray-700 pb-2">
                Contact Info
              </h3>
              <div className="space-y-6">
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 mt-1">
                    <svg
                      className="w-5 h-5 text-gray-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-white font-medium mb-1">Email</h4>
                    <a
                      href="mailto:enquiry@elenoit.com"
                      className="text-gray-300 hover:text-white transition-colors duration-300"
                    >
                      enquiry@elenoit.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 mt-1">
                    <svg
                      className="w-5 h-5 text-gray-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-white font-medium mb-1">Address</h4>
                    <span className="text-gray-300">
                      Office No 414, Ganga Collidium PH-1, Ganga Dham, Pune,
                      Maharashtra 411037
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="border-t border-gray-700 py-6 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-2">
              <div className="container mx-auto px-4">
                <p>
                  &copy; {new Date().getFullYear()} Elenoit. All rights
                  reserved.
                </p>
              </div>
            </div>
            <div className="flex space-x-6">
              <a
                href="/terms-and-conditions"
                target="_blank"
                rel="noreferrer"
                className="text-gray-300 hover:text-white text-sm transition-colors duration-300"
              >
                Terms & Conditions
              </a>

              <a
                href="/privacy-policy"
                target="_blank" // Opens in a new tab
                rel="noreferrer" // Security best practice for target="_blank"
                className="text-gray-300 hover:text-white text-sm transition-colors duration-300"
              >
                {" "}
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
